import { getAPI } from "./axios-base";
import { Role } from "@/models/RoleEnum";

interface ChangeUserPassDto {
  newPassword: string;
  verifyPassword: string;
  userId?: string;
  userRole?: string;
}

export default class RestResourceUser {
  changeUserPassword(body: ChangeUserPassDto) {
    return getAPI.post("api/rest/v1/user/change-password", body);
  }

  getConnectionToken() {
    return getAPI.post("api/rest/v1/user/connection-token");
  }
}
